/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains the Project Management search filter component
------------------------------------------------------------------------------------------------------- */

import { useFormik } from 'formik';
import './ProjectManagementSearch.css';
import Grid from '@mui/material/Grid2';
import CustomAddButton from '../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import { CiSearch } from 'react-icons/ci';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import dayjs from 'dayjs';
import { projectTypeOptions, statusOptions } from '../../../../utils/constants';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';

function ProjectManagementSearch({ tableTitle, isAddEdiModalOpen, handleAddEditModal, searchFilter, isAddPermission, on_change_value, on_page_count_update }) {


  // Initialize formik for form state management
  const formik = useFormik({
    initialValues: {
      projcet_type: '',
      ClientName: '',
      start_date: '',
      end_date: '',
      status: '',
      project: '',
      projcet_code: ''
    },
    // onSubmit: (values) => {
    //   searchFilter(values)
    // },
  });

  const resetFilter = () => {

    on_change_value(1)
    on_page_count_update(25)

    formik.setValues({
      projcet_type: '',
      ClientName: '',
      start_date: "",
      end_date: "",
      status: '',
      project: '',
      projcet_code: '',
      ProjectName: ''
    });
    searchFilter({ //FOR UPPDATE THE STATES WHEN RESET CLICK
      projcet_type: '',
      ClientName: '',
      start_date: "",
      end_date: "",
      status: '',
      project: '',
      projcet_code: '',
      ProjectName: ''
    })
  };
  const breadcrumbs = ['Worksites', tableTitle]
  const handlemodal = () => {
    handleAddEditModal(!isAddEdiModalOpen);
  }

  return (
    <div className="project-lookup-search-container">
      <div className="project-lookup-search-sub-container">
        <div className="project-lookup-search-header">
          <div className="project-lookup-search-left">
            <div className="project-table-title">{tableTitle}</div>
            <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
          </div>
          <div className="project-lookup-search-right">
            {isAddPermission && <CustomAddButton label="Add" onClick={handlemodal} />}
          </div>
        </div>
        <div className="search-layout-wrapper">
          <div className="search-filter-container">
            <div className="search-inputs-fields">

              {/* Project Code */}
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <CustomTextFieldWithIcon
                  name="ProjectName"
                  placeholder="Search by Project Name"
                  value={formik.values.ProjectName}
                  onChange={formik.handleChange}
                  width="100%"
                />
              </Grid>


              {/* Project Code */}
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <CustomTextFieldWithIcon
                  name="projcet_code"
                  placeholder="Search by Project Code"
                  value={formik.values.projcet_code}
                  onChange={formik.handleChange}
                  width="100%"
                />
              </Grid>

              {/* Filters section */}
              <Grid item xs={12} sm={6} md={2}>
                <CustomSelectDropdown
                  name="projcet_type"
                  placeholder="Select Type"
                  options={projectTypeOptions}
                  value={projectTypeOptions?.find(option => option?.value === formik?.values?.projcet_type) || ""}
                  onChange={(selectedOption) => {
                    formik.setFieldValue("projcet_type", selectedOption ? selectedOption.value : "");
                  }}

                  isMulti={false} // Set to false for single-select
                  width="200px"
                />
              </Grid>

              {/* Client Name */}
              <Grid item xs={12} sm={12} md={3} lg={2}>
                <CustomTextFieldWithIcon
                  name="ClientName"
                  placeholder="Search by Client"
                  value={formik.values.ClientName}
                  onChange={formik.handleChange}
                  StartIcon={CiSearch}
                  width="100%"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <CustomDatePicker
                  name="start_date"
                  label="From Date"
                  onChange={(date) => {
                    formik.setFieldValue("start_date", date);
                  }}
                  onBlur={formik.handleBlur}
                  // value={dayjs(formik.values.start_date, "DD-MM-YYYY")}
                  value={formik.values.start_date ? dayjs(formik.values.start_date, "DD-MM-YYYY") : null}
                  width="200px"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <CustomDatePicker
                  name="end_date"
                  label="End Date"
                  onChange={(date) => {
                    formik.setFieldValue("end_date", date);
                  }}
                  onBlur={formik.handleBlur}
                  value={formik.values.end_date ? dayjs(formik.values.end_date, "DD-MM-YYYY") : null}
                  minDate={dayjs(formik.values.start_date, "DD-MM-YYYY")} // Set minimum date
                  width="200px"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <CustomSelectDropdown
                  name="status"
                  placeholder="Select Status"
                  options={statusOptions}
                  value={statusOptions?.find(option => option?.value === formik?.values?.status) || ""}
                  onChange={(selectedOption) => {
                    formik.setFieldValue("status", selectedOption ? selectedOption.value : "");
                  }}
                  onBlur={formik.handleBlur}
                  isDisabled={false}
                  isMulti={false} // Set to false for single-select
                  width="200px"
                />
              </Grid>
            </div>

            {/* Search Button */}
            <div className="search-buttons-fixed-right">
              <ActionButton
                // onClick={formik.handleSubmit}
                onClick={() => {
                  on_change_value(1)
                  searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                }}
                btnDisable={false}
                label="Search"
                btnType="primary"
              />
              <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
            </div>

          </div>
        </div>


      </div>
    </div>
  );
}

export default ProjectManagementSearch;
